import { BoxProps, ColorOptions, TextProps } from '@jfs/ui-new'
import { defaultColors } from '@jfs/ui-new/src/theme/DefaultTheme'
import { ViewStyle } from 'react-native'

const styles = {
  containerView: {
    flex: 1,
    backgroundColor: 'LIGHT_GREY_SEPARATOR',

    alignItems: 'center',
  } as BoxProps,
  scrollView: {
    alignItems: 'center',
    flex: 1,
  } as ViewStyle,
  contentView: {
    marginTop: 16,
    alignItems: 'center',
  } as BoxProps,
  payBtn: { marginTop: 16, bottom: 0, alignSelf: 'center', right: 0 } as BoxProps,
  expiryTextView: { marginVertical: 24, alignItems: 'center', width: '100%' } as BoxProps,
  expiryText: (theme: any) =>
    ({
      paddingVertical: 4,
      color: theme?.bodyTextColor as ColorOptions,
      fontSize: 12,
      fontWeight: '500',
      letterSpacing: 0,
      fontFamily: 'jioType-medium',
    } as TextProps),
  progressView: {
    height: 20,
    width: '100%',
    backgroundColor: 'WHITE',
    borderColor: 'DARK_GREY',
    borderWidth: 0.1,
    borderRadius: 7,
  } as BoxProps,
  infoListView: {
    flex: 1,
    overflow: 'hidden',
    alignItems: 'center',
  } as BoxProps,
  textContainer: { flex: 1 } as BoxProps,
  itemView: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
    paddingVertical: 16,
  } as BoxProps,
  imageView: {
    width: 118,
    height: 88,
  },
  titleText: {
    color: 'LIGHT_GREY',
    fontSize: 10,
    fontWeight: '500',
    fontFamily: 'jioType-medium',
  } as TextProps,
  animationStyle: {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: defaultColors.PRIMARY,
    borderRadius: 5,
  } as ViewStyle,
  detailText: (theme: any) =>
    ({
      color: theme?.bodyTextColor as ColorOptions,
      fontSize: 12,
      fontWeight: '500',
      fontFamily: 'jioType-medium',
    } as TextProps),
  bulletPoint: { width: 30, alignItems: 'center', justifyContent: 'center' } as BoxProps,
  bulletCircle: { width: 8, height: 8, borderRadius: 4, backgroundColor: 'BORDER_COLOR' } as BoxProps,
  lineView: { width: 2, backgroundColor: 'BORDER_COLOR' } as BoxProps,
  noteView: {
    marginTop: 40,
    width: '100%',
    alignItems: 'center',
  } as BoxProps,
  noteText: {
    flex: 1,
    paddingVertical: 8,
    paddingHorizontal: 8,
    color: 'SECONDARY_GREY',
    fontSize: 12,
    fontWeight: '500',
    zIndex: 10,
    fontFamily: 'jioType-medium',
  } as TextProps,
  noteBgView: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    backgroundColor: 'YELLOW',
    opacity: 0.25,
  } as BoxProps,
  bulletView: { flexDirection: 'row', width: '100%' } as BoxProps,
}

export default styles
